export default __webpack_public_path__ + "static/media/img_erp_phone.d8c1de83.png";